import React, { Component } from 'react';

class Repositories extends Component {
    

    constructor(props) {
	  super(props);
        
	  this.state = {
        listItems: [],
        inputText: '',
        loading: true,
        timeout: 0
	  };
        this.inputChanged = this.inputChanged.bind(this);
	}
	componentDidMount() {
	   this.fetch();
	}
    componentDidUpdate(prevProps, prevState) {
        
        if (this.state.inputText !== prevState.inputText) {
            if (this.state.timeout) {
                clearTimeout(this.state.timeout);
            }
            this.setState({
                timeout:setTimeout((event)=> this.fetch(), 1500)
            });
            
        }
        if (this.state.listItems !== prevState.listItems) {
            this.setState({
                loading: false
            });
        }
    }
    fetch() {
        this.setState({
			loading: true
        });
        console.log("trying to fetch now!");
        let url = "https://api.github.com/search/repositories?q=";
        url+=this.state.inputText===''?'react':this.state.inputText;
        console.log("url is " + url);
        fetch(url)
		.then((response) => response.json())
		.then((responseData) => {
            this.setState({
				listItems: responseData.items
			});
		});
        
    }
    inputChanged = (event) => {
        
        this.setState({
            inputText: event.target.value
        });
    }
  render() {
      const itemRows = this.state.listItems.map((repo) => 
          <tr key={repo.id}>
            <td>{repo.full_name}</td>
            <td><a class="w3-padding-small w3-hover-theme" href={repo.html_url}>{repo.html_url}</a></td>
          </tr>
      );
      let table;
      if (this.state.loading) {
          table = (
              <div class="w3-container w3-padding-large w3-center">
                  <div class=" w3-text-white w3-panel w3-light-green w3-card-4 w3-section" style={{"max-width":600, "margin":"0 auto"}}>
                    <h2>Loading</h2>
                    <p><i class="fa fa-spinner w3-spin" style={{"font-size":64}}></i></p>
                  </div>
              </div>
              )
      } else if (this.state.listItems.length > 0) {
          table = (
            <div class="w3-responsive">
              <table class="w3-table w3-bordered w3-hoverable">
                <tbody>
                  <tr class="w3-theme-l3"><th>Name</th><th>URL</th></tr>
                  {itemRows}
                </tbody>
            </table>
          </div>
          )
      } else {
          table = (
           <div class="w3-container w3-padding-large">
              <h2>No results!</h2>
            </div>
          )
      }
      
    return (
	<div class="w3-container w3-padding-large">
        <h2>GitHub Repositories</h2>
        <div class="w3-bar w3-border-bottom w3-section">
            <i class="w3-bar-item fa fa-search w3-text-grey" 
             style={{"padding-right":0, "line-height":22, "width":30}}></i>
            <input class="w3-bar-item w3-input w3-light-grey" style={{"width":"90%"}} autoFocus type="text" placeholder="Search repositories..." 
                onChange={this.inputChanged} value={this.state.inputText} />
        </div>
        {table}
    </div>
    );
  }
}

export default Repositories;



// WEBPACK FOOTER //
// ./src/Repositories.js